import React from 'react';
import { Label, Icon } from '@nooz-optics/nooz-components-lib';
import { formatContentfulComponentProps } from '../../../../../../utils/globals';
import { Body } from '../../../../../UI/Elements';
import { Disclosure } from '../../../../../UI/Navigation/Disclosure/disclosure';
import { List } from '../../../../../UI/Navigation/List/list';
import { IProduct } from '../../../../../utils/types/contentful';
import { ProductMainUsp } from '../../Usp/productMainUsp';

export interface ProductMainVariantDetailsInfosProps {
  product: IProduct;
}

const ProductMainVariantDetailsInfo = ({
  icon,
  body,
  label,
  productUsp,
  defaultOpen,
}) => {
  const returnDetailsContent = () => {
    if (body) {
      return (
        <div className='py-4'>
          <Body {...body} />
        </div>
      );
    }
    if (icon) {
      return (
        <div className='py-4 w-2/3'>
          <Icon
            {...icon}
            width='100%'
          />
        </div>
      );
    }
    if (productUsp) {
      return (
        <div className='py-4'>
          <ProductMainUsp usps={productUsp.items[0]} />
        </div>
      );
    }
  };

  const DetailsInfoLabel = (
    <Label
      {...label}
      color={{ classname: 'gray-800' }}
      size='base'
      weight='normal'
    />
  );

  const DetailsInfoIcon = (
    <Icon
      iconKey='HiChevronDown'
      size='2xl'
      color={{ classname: 'primary' }}
    />
  );

  return (
    <Disclosure
      defaultOpen={defaultOpen}
      button={DetailsInfoLabel}
      chevronIcon={DetailsInfoIcon}>
      {returnDetailsContent()}
    </Disclosure>
  );
};

export const ProductMainVariantDetailsInfos: React.FC<
  ProductMainVariantDetailsProps
> = ({ informations }) => (
  <List
    divide
    listItems={informations?.map((information, index) => ({
      spacing: 'py-2',
      children: (
        <ProductMainVariantDetailsInfo
          {...formatContentfulComponentProps(information)}
          defaultOpen={index === 0}
        />
      ),
    }))}
  />
);
